import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Institute, InstituteDto } from '../constants/institute.constants';
import { AuthenticationService } from '../../service/admin-console/authentication/authentication.service';
import { AuthenticationResponseDto } from '../../service/admin-console/authentication/model/AuthenticationResponseDto';

@Injectable({
  providedIn: 'root',
})
export class SelectedInstituteService {
  private SELECTED_INSTITUTE_STORAGE = 'selected-institute';

  private instituteSource = new BehaviorSubject<InstituteDto | null>(null);

  selectedInstitute$ = this.instituteSource.asObservable();

  private readonly authService = inject(AuthenticationService);

  setInstitute(
    institute: InstituteDto,
    storeInLocalStorage: boolean = true
  ): void {
    this.instituteSource.next(institute);
    if (storeInLocalStorage) {
      this.storeSelectedInstitute(institute);
    }
  }

  getInstitutes(): InstituteDto[] {
    const session: AuthenticationResponseDto | null =
      this.authService.getSessionData();
    if (!session || !Array.isArray(session.privileges)) {
      return [];
    }

    const userPrivileges = session.privileges;
    return Institute.list.filter(inst => {
      if (!inst.requiredPrivileges || inst.requiredPrivileges.length === 0) {
        return true;
      }

      // Return true if user has at least one required privilege for the institute
      return inst.requiredPrivileges.some(priv =>
        userPrivileges.includes(priv)
      );
    });
  }

  getSelectedInstitute(): InstituteDto {
    if (!this.instituteSource.value) {
      return Institute.BAWAG;
    }

    return this.instituteSource.value;
  }

  private storeSelectedInstitute(institute: InstituteDto): void {
    localStorage.setItem(
      this.SELECTED_INSTITUTE_STORAGE,
      JSON.stringify(institute)
    );
  }

  public initSelectedInstitute(): void {
    const storedData = localStorage.getItem(this.SELECTED_INSTITUTE_STORAGE);
    if (storedData) {
      try {
        const institute = JSON.parse(storedData) as InstituteDto;
        this.instituteSource.next(
          this.getInstitutes().find(i => i.entity === institute.entity) ||
            Institute.BAWAG
        );
      } catch (error) {
        console.error('Failed to parse stored institute:', error);
      }
    } else {
      this.instituteSource.next(Institute.BAWAG);
    }
  }

  getInstituteById(id: string): InstituteDto | null {
    return (
      Institute.FullList.find(institute => institute.entity === id) || null
    );
  }

  mapInstituteForEmployeeEntity(instituteEntity: string): string {
    if (
      instituteEntity === Institute.PSK.entity ||
      instituteEntity === Institute.SPARDA.entity
    ) {
      return Institute.BAWAG.entity;
    }

    return instituteEntity;
  }
}
